/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'app/components/ui/select';
import { useFormContext } from 'react-hook-form';

function Publish() {
  const form = useFormContext();

  return (
    <div className="rounded-md bg-white  dark:bg-transparent p-4">
      <h2 className="text-sm mb-2 font-semibold">Status</h2>

      <Select
        onValueChange={val => form.setValue('status', val)}
        defaultValue={'published'}
      >
        <SelectTrigger className="border border-gray-300 rounded px-2 py-1 w-full">
          <SelectValue placeholder="Published" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="published">Published</SelectItem>
          <SelectItem value="draft">Draft</SelectItem>
          <SelectItem value="archived">Archived</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
export default Publish;
